module.exports = __webpack_public_path__ + "img/theme12.064b6ec2.png";